export default class SearchResultsLoadMore {

	constructor() {
		this.settings = {
			$searchResultsList: $(".js-search-results-list")
		};

		this.bindUIActions();
	}

	bindUIActions() {

		if (this.settings.$searchResultsList != null) {

			let searchResultsList = this.settings.$searchResultsList;
			let postsToShow = $('#search-results-to-show').val();
			let allPosts = $('.js-search-result-single').length;
			let loadMoreBtn = $(".js-search-result-load-more");

			function postTypeList() {
				$('.js-search-result-single').removeClass('hidden');

				searchResultsList.find('.js-search-result-single').each(function(index) {

					// Hide posts
					if (index >= postsToShow) {
						$(this).addClass('hidden');
					}
				});
			}

			postTypeList();

			// Default number of posts to show
			let shownByDefault = $('.js-search-result-single:not(.hidden)').length;
			$('.js-shown-articles').text(shownByDefault);

			if (shownByDefault < postsToShow) {
				loadMoreBtn.removeClass('btn');
				loadMoreBtn.addClass('hidden');
			}

			loadMoreBtn.on('click', function() {

				let morePosts = searchResultsList.find('.hidden');
				let counter = 0;

				morePosts.each(function() {

					// Show more posts
					if (counter >= postsToShow) {
						return false;
					}

					counter++;

					$(this).removeClass('hidden');
				});

				let postsShown = allPosts - $('.js-search-result-single.hidden').length;
				$('.js-shown-articles').text(postsShown);

				if (searchResultsList.find('.hidden').length === 0) {
					$(this).removeClass('btn');
					$(this).addClass('hidden');
				}

			});

		}

	}
};

new SearchResultsLoadMore();